<script>
  
import MarqueeText from 'vue-marquee-text-component';

export default {
    data() {
        return {
          isPaused: false,
        };
    },
    
    props: {
      duration: {
        type: Number,
        default: 30,
      },
    },
    
    computed: {

    },
    
    watch: {

    },
    
    methods: {
      didHoverMarquee: function() {
        this.isPaused = true;
      },
      didLeaveMarquee: function() {
        this.isPaused = false;
      },
    },
    
    components: {
      MarqueeText,
    },
    
    created() {
      
    },
    mounted() {
      //this.testObject
    },
};

</script>

<style>

</style>

<template>

  <section class="es-container" 
            v-on:mouseover="didHoverMarquee"
            v-on:mouseleave="didLeaveMarquee"
    >
    <marquee-text :paused="isPaused" :duration="duration">
      <slot></slot>
    </marquee-text>
  </section>

</template>
